(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    const RECAPTCHA_SITE_KEY = '6Ldfl40sAAAAAG9kef0H3kL-y_xOzksfJ1i2Khnq';

  document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll('.contact-form__form');

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        if (!window.grecaptcha) return;

        e.preventDefault();
        const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        grecaptcha.ready(function() {
          grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'contact' }).then(function(token) {
            let tokenInput = form.querySelector('input[name="g-recaptcha-response"]');
            if (!tokenInput) {
              tokenInput = document.createElement('input');
              tokenInput.type = 'hidden';
              tokenInput.name = 'g-recaptcha-response';
              form.appendChild(tokenInput);
            }
            tokenInput.value = token;
            form.submit();
          }).catch(function(err) {
            console.error('reCAPTCHA error:', err);
            if (submitBtn) submitBtn.disabled = false;
          });
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mui-cart-page"] && !Shopify.designMode) return;
  try {
    (function() {
    // ============================================================
    // AUTOMATIC CART PERSISTENCE FOR LOGGED-IN CUSTOMERS
    // - Saves cart to customer record when items change
    // - Restores cart when customer returns with empty cart
    // ============================================================
    var PROXY_API = 'https://api.anointedautomation.net/api';
    var cartSection = document.querySelector('.mui-cart');
    var customerEmail = cartSection ? cartSection.getAttribute('data-customer-email') : '';
    var currentCartCount = cartSection ? parseInt(cartSection.getAttribute('data-cart-count') || '0', 10) : 0;

    // Save current cart to customer record (for logged-in customers only)
    function saveCartToCustomer() {
      if (!customerEmail) return; // Only for logged-in customers

      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          if (cart && cart.Data !== undefined && cart.data === undefined) { cart.data = cart.Data; }
          if (!cart.items || cart.items.length === 0) {
            // Clear saved cart when cart is empty
            return fetch(PROXY_API + '/shopify/anointed/customer/cart', {
              method: 'DELETE',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: customerEmail })
            });
          }

          // Save cart items to customer record
          var cartData = {
            email: customerEmail,
            cart: {
              items: cart.items.map(function(item) {
                return {
                  variant_id: item.variant_id,
                  quantity: item.quantity,
                  product_title: item.product_title,
                  variant_title: item.variant_title,
                  price: item.price,
                  image: item.image
                };
              }),
              total_price: cart.total_price,
              item_count: cart.item_count
            }
          };

          return fetch(PROXY_API + '/shopify/anointed/customer/cart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData)
          });
        })
        .then(function(response) {
          if (response && response.ok) {
            console.log('[Cart Save] Cart saved to customer record');
          }
        })
        .catch(function(err) {
          console.error('[Cart Save] Error:', err);
        });
    }

    // Save cart on page load if customer is logged in and has items
    if (customerEmail && currentCartCount > 0) {
      saveCartToCustomer();
    }

    // Restore cart if customer is logged in with empty cart
    if (customerEmail && currentCartCount === 0) {
      fetch(PROXY_API + '/shopify/anointed/customer/cart/' + encodeURIComponent(customerEmail))
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data && data.Data !== undefined && data.data === undefined) { data.data = data.Data; }
          var _restoreCart = (data.data && data.data.cart) || data.cart;
          if (data.success && _restoreCart && _restoreCart.items && _restoreCart.items.length > 0) {
            showRestorePrompt(_restoreCart);
          }
        })
        .catch(function(err) { console.error('[Cart Restore] Error:', err); });
    }

    function showRestorePrompt(savedCart) {
      var banner = document.createElement('div');
      banner.id = 'cart-restore-banner';
      banner.style.cssText = 'background: linear-gradient(135deg, #7c4dff 0%, #536dfe 100%); color: #fff; padding: 16px 20px; border-radius: 12px; margin-bottom: 24px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; box-shadow: 0 4px 12px rgba(124, 77, 255, 0.3);';
      banner.innerHTML = '<div style="display: flex; align-items: center; gap: 12px;"><svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg><div><strong>Welcome back!</strong><br><span style="font-size: 0.9rem; opacity: 0.9;">You have ' + savedCart.items.length + ' item(s) in your saved cart</span></div></div>';

      var btnDiv = document.createElement('div');
      btnDiv.style.cssText = 'display: flex; gap: 10px;';

      var restoreBtn = document.createElement('button');
      restoreBtn.style.cssText = 'background: #fff; color: #7c4dff; border: none; padding: 10px 20px; border-radius: 6px; font-weight: 600; cursor: pointer;';
      restoreBtn.textContent = 'Restore Cart';

      var dismissBtn = document.createElement('button');
      dismissBtn.style.cssText = 'background: transparent; color: #fff; border: 2px solid rgba(255,255,255,0.5); padding: 10px 16px; border-radius: 6px; font-weight: 500; cursor: pointer;';
      dismissBtn.textContent = 'No thanks';

      btnDiv.appendChild(restoreBtn);
      btnDiv.appendChild(dismissBtn);
      banner.appendChild(btnDiv);

      var container = document.querySelector('.mui-cart__container');
      if (container) container.insertBefore(banner, container.firstChild.nextSibling);

      restoreBtn.addEventListener('click', function() {
        restoreBtn.textContent = 'Restoring...';
        restoreBtn.disabled = true;
        Promise.all(savedCart.items.map(function(item) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.variant_id, quantity: item.quantity })
          });
        })).then(function() { location.reload(); }).catch(function() { location.reload(); });
      });

      dismissBtn.addEventListener('click', function() { banner.remove(); });
    }

    // ============================================================
    // Clear cart button
    var clearBtn = document.getElementById('clear-cart-btn');
    if (clearBtn) {
      var originalText = clearBtn.textContent;
      clearBtn.addEventListener('click', function() {
        if (confirm('Are you sure you want to clear your cart?')) {
          clearBtn.disabled = true;
          clearBtn.textContent = 'Clearing...';
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          })
          .then(function() {
            // Clear saved cart from customer record
            if (customerEmail) {
              return fetch(PROXY_API + '/shopify/anointed/customer/cart', {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: customerEmail })
              });
            }
          })
          .then(function() {
            location.reload();
          })
          .catch(function(error) {
            console.error('Error clearing cart:', error);
            clearBtn.disabled = false;
            clearBtn.textContent = originalText;
          });
        }
      });
    }

    // Quantity controls
    document.querySelectorAll('.mui-qty-minus').forEach(btn => {
      btn.addEventListener('click', function() {
        const line = this.dataset.line;
        const input = document.querySelector(`.mui-qty-input[data-line="${line}"]`);
        const newQty = Math.max(1, parseInt(input.value) - 1);
        updateCartItem(line, newQty);
      });
    });

    document.querySelectorAll('.mui-qty-plus').forEach(btn => {
      btn.addEventListener('click', function() {
        const line = this.dataset.line;
        const input = document.querySelector(`.mui-qty-input[data-line="${line}"]`);
        const newQty = Math.min(99, parseInt(input.value) + 1);
        updateCartItem(line, newQty);
      });
    });

    document.querySelectorAll('.mui-qty-input').forEach(input => {
      input.addEventListener('change', function() {
        const line = this.dataset.line;
        const newQty = Math.max(1, Math.min(99, parseInt(this.value) || 1));
        updateCartItem(line, newQty);
      });
    });

    // Remove buttons
    document.querySelectorAll('.mui-cart__item-remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const line = this.dataset.line;
        updateCartItem(line, 0);
      });
    });

    // Last-minute variant swap: remove the line, add the chosen variant at the same quantity.
    document.querySelectorAll('.mui-cart__variant-select').forEach(sel => {
      sel.addEventListener('change', function() {
        const newId = parseInt(this.value);
        const current = parseInt(this.dataset.current);
        if (!newId || newId === current) { return; }
        const line = parseInt(this.dataset.line);
        const qty = parseInt(this.dataset.qty) || 1;
        this.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        })
        .then(r => { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(() => fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: newId, quantity: qty })
        }))
        .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(() => {
          if (customerEmail) { saveCartToCustomer(); }
          location.reload();
        })
        .catch(err => {
          console.error('Error swapping variant:', err);
          // Reload regardless so the cart never shows a stale line after a partial swap.
          location.reload();
        });
      });
    });

    function updateCartItem(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: quantity })
      })
      .then(response => response.json())
      .then(data => {
        if (data && data.Data !== undefined && data.data === undefined) { data.data = data.Data; }
        // Save updated cart to customer record before reload
        if (customerEmail) {
          saveCartToCustomer();
        }
        location.reload();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    }

    // ============================================================
    // EMAIL CAPTURE + CHECKOUT WITH EMAIL PRE-FILL
    // ============================================================
    var emailInput = document.getElementById('mui-cart-recovery-email');
    var saveBtn = document.getElementById('mui-save-email-btn');
    var savedMsg = document.getElementById('mui-email-saved-msg');
    var requiredMsg = document.getElementById('mui-email-required-msg');
    var checkoutBtn = document.getElementById('mui-checkout-btn');
    var checkoutText = document.getElementById('mui-checkout-text');
    var customerEmailSpan = document.getElementById('mui-customer-email');

    // Track if email has been saved (for guests)
    var emailSaved = false;

    // Get email - either from logged-in customer or saved input
    function getCheckoutEmail() {
      // Logged-in customer
      if (customerEmailSpan) {
        return customerEmailSpan.textContent.trim();
      }
      // Guest with saved email
      if (emailInput && emailSaved) {
        return emailInput.value.trim();
      }
      return '';
    }

    // Check if email was already saved in cart attributes (page reload)
    if (emailInput && emailInput.value && emailInput.value.trim() !== '') {
      emailSaved = true;
      if (savedMsg) savedMsg.style.display = 'flex';
      if (requiredMsg) requiredMsg.classList.add('hidden');
      if (checkoutBtn) {
        checkoutBtn.disabled = false;
        if (checkoutText) checkoutText.textContent = 'Secure Checkout';
      }
    }

    // Guest email save handler
    if (emailInput && saveBtn) {
      saveBtn.addEventListener('click', function() {
        var email = emailInput.value.trim();
        if (!email || !email.includes('@')) {
          emailInput.focus();
          emailInput.style.borderColor = '#d32f2f';
          return;
        }

        saveBtn.disabled = true;
        saveBtn.textContent = '...';
        emailInput.style.borderColor = '';

        // Save to cart attributes for abandoned cart recovery
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { recovery_email: email } })
        })
        .then(function(response) {
          if (response.ok) {
            // Also create customer via proxy API (for marketing)
            return fetch('https://api.anointedautomation.net/api/shopify/anointed/customer-signup', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: email })
            });
          }
          throw new Error('Cart update failed');
        })
        .then(function() {
          // Email saved successfully
          emailSaved = true;
          if (savedMsg) savedMsg.style.display = 'flex';
          if (requiredMsg) requiredMsg.classList.add('hidden');
          saveBtn.textContent = 'Saved';

          // Enable checkout button
          if (checkoutBtn) {
            checkoutBtn.disabled = false;
            if (checkoutText) checkoutText.textContent = 'Secure Checkout';
          }
        })
        .catch(function(err) {
          console.error('Email save error:', err);
          // Still mark as saved for cart recovery even if proxy API fails
          emailSaved = true;
          if (savedMsg) savedMsg.style.display = 'flex';
          if (requiredMsg) requiredMsg.classList.add('hidden');
          saveBtn.textContent = 'Saved';

          if (checkoutBtn) {
            checkoutBtn.disabled = false;
            if (checkoutText) checkoutText.textContent = 'Secure Checkout';
          }
        });
      });

      emailInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          saveBtn.click();
        }
      });
    }

    // ============================================================
    // CHECKOUT BUTTON - Redirect with pre-filled customer data
    // Uses cart permalink format which properly passes checkout params
    // ============================================================
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function() {
        var email = getCheckoutEmail();

        if (!email) {
          // No email - focus on input
          if (emailInput) {
            emailInput.focus();
            emailInput.style.borderColor = '#d32f2f';
          }
          return;
        }

        // Disable button while processing
        checkoutBtn.disabled = true;
        if (checkoutText) checkoutText.textContent = 'Processing...';

        // Fetch current cart to build permalink with all items
        fetch('/cart.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            if (cart && cart.Data !== undefined && cart.data === undefined) { cart.data = cart.Data; }
            if (!cart.items || cart.items.length === 0) {
              alert('Your cart is empty');
              checkoutBtn.disabled = false;
              if (checkoutText) checkoutText.textContent = 'Secure Checkout';
              return;
            }

            // Build cart permalink: /cart/variant:qty,variant:qty?checkout[email]=...
            var cartItems = cart.items.map(function(item) {
              return item.variant_id + ':' + item.quantity;
            }).join(',');

            // Start building checkout params
            var params = [];
            params.push('checkout[email]=' + encodeURIComponent(email));

            // For logged-in customers, add shipping address data
            if (cartSection) {
              var firstName = cartSection.getAttribute('data-customer-first-name');
              var lastName = cartSection.getAttribute('data-customer-last-name');
              var address1 = cartSection.getAttribute('data-customer-address1');
              var address2 = cartSection.getAttribute('data-customer-address2');
              var city = cartSection.getAttribute('data-customer-city');
              var province = cartSection.getAttribute('data-customer-province');
              var country = cartSection.getAttribute('data-customer-country');
              var zip = cartSection.getAttribute('data-customer-zip');
              var phone = cartSection.getAttribute('data-customer-phone');

              if (firstName) params.push('checkout[shipping_address][first_name]=' + encodeURIComponent(firstName));
              if (lastName) params.push('checkout[shipping_address][last_name]=' + encodeURIComponent(lastName));
              if (address1) params.push('checkout[shipping_address][address1]=' + encodeURIComponent(address1));
              if (address2) params.push('checkout[shipping_address][address2]=' + encodeURIComponent(address2));
              if (city) params.push('checkout[shipping_address][city]=' + encodeURIComponent(city));
              if (province) params.push('checkout[shipping_address][province]=' + encodeURIComponent(province));
              if (country) params.push('checkout[shipping_address][country]=' + encodeURIComponent(country));
              if (zip) params.push('checkout[shipping_address][zip]=' + encodeURIComponent(zip));
              if (phone) params.push('checkout[shipping_address][phone]=' + encodeURIComponent(phone));
            }

            var checkoutUrl = '/cart/' + cartItems + '?' + params.join('&');

            // Redirect to cart permalink (triggers checkout with pre-filled data)
            window.location.href = checkoutUrl;
          })
          .catch(function(err) {
            console.error('Checkout error:', err);
            // Fallback to standard checkout
            window.location.href = '/checkout';
          });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
